import { basePropertyOfDeep } from './base'

export default function propertyOf(data) {
  return basePropertyOfDeep(data)
}
